module.exports = __webpack_public_path__ + "static/google-play-badge-cc9b54376620338b34cca5e09b6fdaaa.svg";